"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TopType;
(function (TopType) {
    TopType["NoHair"] = "NoHair";
    TopType["Eyepatch"] = "Eyepatch";
    TopType["Hat"] = "Hat";
    TopType["Hijab"] = "Hijab";
    TopType["Turban"] = "Turban";
    TopType["WinterHat1"] = "WinterHat1";
    TopType["WinterHat2"] = "WinterHat2";
    TopType["WinterHat3"] = "WinterHat3";
    TopType["WinterHat4"] = "WinterHat4";
    TopType["LongHairBigHair"] = "LongHairBigHair";
    TopType["LongHairBob"] = "LongHairBob";
    TopType["LongHairBun"] = "LongHairBun";
    TopType["LongHairCurly"] = "LongHairCurly";
    TopType["LongHairCurvy"] = "LongHairCurvy";
    TopType["LongHairDreads"] = "LongHairDreads";
    TopType["LongHairFrida"] = "LongHairFrida";
    TopType["LongHairFro"] = "LongHairFro";
    TopType["LongHairFroBand"] = "LongHairFroBand";
    TopType["LongHairNotTooLong"] = "LongHairNotTooLong";
    TopType["LongHairShavedSides"] = "LongHairShavedSides";
    TopType["LongHairMiaWallace"] = "LongHairMiaWallace";
    TopType["LongHairStraight"] = "LongHairStraight";
    TopType["LongHairStraight2"] = "LongHairStraight2";
    TopType["LongHairStraightStrand"] = "LongHairStraightStrand";
    TopType["ShortHairDreads01"] = "ShortHairDreads01";
    TopType["ShortHairDreads02"] = "ShortHairDreads02";
    TopType["ShortHairFrizzle"] = "ShortHairFrizzle";
    TopType["ShortHairShaggyMullet"] = "ShortHairShaggyMullet";
    TopType["ShortHairShortCurly"] = "ShortHairShortCurly";
    TopType["ShortHairShortFlat"] = "ShortHairShortFlat";
    TopType["ShortHairShortRound"] = "ShortHairShortRound";
    TopType["ShortHairShortWaved"] = "ShortHairShortWaved";
    TopType["ShortHairSides"] = "ShortHairSides";
    TopType["ShortHairTheCaesar"] = "ShortHairTheCaesar";
    TopType["ShortHairTheCaesarSidePart"] = "ShortHairTheCaesarSidePart";
})(TopType || (TopType = {}));
exports.default = TopType;
